module.exports = __webpack_public_path__ + "static/design-3-ab177650bf8a8d534ad52d8dd8eb1370.png";